export default __webpack_public_path__ + "static/media/ic-arrow-head-up.f70e384c.svg";